import React from 'react';

export default function DeleteConfirmModal({ vendorName, onClose, onConfirm }) {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
            <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md">
                <h2 className="text-xl font-bold text-red-600 mb-4">Confirm Deletion</h2>
                <p className="text-gray-600 mb-6">
                    Are you sure you want to permanently delete <strong className="font-semibold">{vendorName}</strong>? This action cannot be undone.
                </p>
                <div className="flex justify-end space-x-4 mt-6">
                    <button onClick={onClose} className="px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg hover:bg-gray-300">
                        Cancel
                    </button>
                    <button onClick={onConfirm} className="px-6 py-2 bg-red-600 text-white font-medium rounded-lg hover:bg-red-700">
                        Confirm Deletion
                    </button>
                </div>
            </div>
        </div>
    );
}